import { render, staticRenderFns } from "./TopicCommentArea.vue?vue&type=template&id=987a54dc&"
import script from "./TopicCommentArea.vue?vue&type=script&lang=ts&"
export * from "./TopicCommentArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports